import { Id } from './Id';

export type Ref<T extends { ref: Ref<T> }> = {
  id: string,
  _refTypeGuard: {} | T, // never actually T
};

export function Ref<T extends { ref: Ref<T> }>(
  uniformRand: () => number = Math.random
): Ref<T> {
  return {
    id: Id(uniformRand),
    _refTypeGuard: {},
  };
}

export namespace Ref {
  export function equals<T extends { ref: Ref<T> }>(
    a: Ref<T> | null,
    b: Ref<T> | null
  ): boolean {
    return !a || !b ? a === b : a.id === b.id;
  }

  export function fromId<T extends { ref: Ref<T> }>(id: string): Ref<T> {
    return {
      id,
      _refTypeGuard: {},
    };
  }
}

export default Ref;



// WEBPACK FOOTER //
// ./src/util/Ref.ts